import { ModifyAudioDeviceCamMappingPayload } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useAudioDeviceAddCamMapping(onSuccess?: () => void) {
  const url = `/v2/orm/audio_devices/mapping`;

  const request = new Request(url, {
    method: 'POST',
  });

  return useAuthenticatedMutation<null, ModifyAudioDeviceCamMappingPayload>(
    request,
    {
      onSuccess,
      onSuccessInvalidationKeys: [['audio']],
    }
  );
}

export default useAudioDeviceAddCamMapping;
